import {STABLECOINS} from '@skeleton/consts/stableCoins';

export const isStablecoin = (currency: string): boolean => {
  return STABLECOINS.includes(currency.toUpperCase());
};
